module.exports = __webpack_public_path__ + "assets/5041e49076ba6736948f93e003dbef15.png";